module.exports = __webpack_public_path__ + "img/ANDALUSIA.e64b5993.jpg";